export default {
    ADD_CONTACT: "contacts/ADD_CONTACT",
    DELETE_CONTACT: "contacts/DELETE_CONTACT",
    CHANGE_CONTACT: "contacts/CHANGE_CONTACT",
    
    FILTER_CONTACT: "contacts/FILTER_CONTACT",

    ADD_ID_EDIT_CONTACT: "contacts/ADD_ID_EDIT_CONTACT",
    DELETE_ID_EDIT_CONTACT: "contacts/DELETE_ID_EDIT_CONTACT"
}